module.exports = __webpack_public_path__ + "media/assets/services_manager/faria-one-logo-1f0af25b8536174f519a89f24996072ef7437d01ec6f23d0c9f615df0ba619a4.png";